import { useState } from "react";
import styles from "./NotesButton.module.scss";
import { IconType } from "../../../icons/Icon";
import { IconButton } from "../../button/iconButton/IconButton";
import { useApiQuery } from "../../../infrastructure/hooks/useApiQuery";
import { INoteViewModel } from "./models/noteModel";
import { NotesDialog } from "./NotesDialog";

interface INotesButtonProps {
  entityId?: number;
  label: string;
  getEndpoint: string;
  createEndpoint: string;
  updateEndpoint: string;
  deleteEndpoint: string;
  noResultsLabel: string;
  iconHeight?: string;
  iconWidth?: string;
  tooltip?: string;
}

export const NotesButton = ({
  entityId,
  label,
  getEndpoint,
  createEndpoint,
  updateEndpoint,
  deleteEndpoint,
  noResultsLabel,
  iconHeight = "30px",
  iconWidth = "30px",
  tooltip = "Бележки",
}: INotesButtonProps) => {
  const [showDialog, setShowDialog] = useState(false);

  const { data: notes } = useApiQuery<INoteViewModel[]>({
    queryKey: [getEndpoint, entityId],
    endpoint: `${getEndpoint}?entityId=${entityId}`,
    enabled: entityId !== undefined && entityId > 0,
    disableErrorToast: true,
    retry: false,
    globalIsLoading: false,
  });

  const count = notes?.length ?? 0;

  return (
    <>
      <div className={styles.wrapper}>
        <IconButton
          iconType={IconType.AddNote}
          iconHeight={iconHeight}
          iconWidth={iconWidth}
          tooltip={tooltip}
          onClick={() => setShowDialog(true)}
        />
        {count > 0 && <span className={styles.badge}>{count}</span>}
      </div>
      <NotesDialog
        entityId={entityId}
        showDialog={showDialog}
        onHide={() => setShowDialog(false)}
        label={label}
        getEndpoint={getEndpoint}
        createEndpoint={createEndpoint}
        updateEndpoint={updateEndpoint}
        deleteEndpoint={deleteEndpoint}
        noResultsLabel={noResultsLabel}
      />
    </>
  );
};
